import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { Global } from "app/@core/lib/global";
import { UserService } from "app/services/user.service";
import { SelectUserComponentModal } from "../select-user.component";

@Component({
    selector: 'asap-select-user',
    templateUrl: './select.component.html',
    //styleUrls: ['./select.component.scss'],
    providers: [UserService]
})
export class SelectUserSelectComponent implements OnChanges {

    @Input() ngModel;
    @Output() ngModelChange = new EventEmitter();

    @Input() multiselect = false;
    @Input() placeholder;

    public display = "";
    public users;

    constructor(
        public global: Global,
        public userService: UserService
    ) {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.ngModel) {
            if (this.ngModel) {
                let same = (this.ngModel == changes.ngModel.previousValue);
                if (!same) {
                    console.log("[arrayEquals]", this.ngModel, changes.ngModel.previousValue)
                    same = this.global.arrayEquals(this.ngModel, changes.ngModel.previousValue);
                }
                if (!same) {
                    console.log("ngModel", same);

                    let ids = "";

                    if (Array.isArray(this.ngModel)) {
                        ids = this.ngModel.join(",");
                    }
                    else {
                        ids = this.ngModel;
                    }

                    if (ids != "") {
                        this.userService.getAllUserData({ id: ids }).subscribe((response) => {
                            this.users = response.data.map(user => {
                                user.selected = true;
                                return user;
                            });
                            if (Array.isArray(response.data)) {
                                let display = "";
                                response.data.forEach(user => {
                                    if (display != "") display += ", ";
                                    display += user.name;
                                });
                                this.display = display;
                            }
                            else {
                                this.display = response.data.name;
                            }
                        });
                    }
                }
            }
            else {
                this.display = "";
            }
        }
    }

    public canRemove() {
        if (this.ngModel) {
            if (Array.isArray(this.ngModel)) {
                return this.ngModel.length > 0;
            }
            return true;
        }

        return false;
    }

    public removeUser() {
        this.ngModel = null;
        this.ngModelChange.emit(null);
    }

    public selectUser() {
        this.global.dialog.open(SelectUserComponentModal, {
            width: '550px',
            data: {
                selection: this.ngModel,
                searchList: this.users,
                asapClient: false,
                multiselect: this.multiselect
            }
        }).afterClosed().subscribe((response) => {
            if (response) {
                if (Array.isArray(response)) {
                    let value = [];
                    let display = "";
                    console.log('Rresponse ->', response);
                    this.users = response;
                    response.forEach(user => {
                        let id;

                        if (user.user_info) {
                            id = user.user_info.user_id;
                        }
                        else {
                            id = user.user_id
                        }

                        value.push(id);

                        if (display != "") display += ", ";
                        display += user.name;

                        let idx = this.users.findIndex(u => ((u.user_info) ? u.user_info.user_id : user.user_id) == id);
                        if (idx < 0) {
                            this.users.push(user);
                        }
                    });
                    this.ngModel = value;
                    this.ngModelChange.emit(value);
                    this.display = display;
                }
                else {
                    if (response.user_info) {
                        this.ngModel = response.user_info.user_id;
                        this.ngModelChange.emit(response.user_info.user_id);
                        this.display = response.name;
                    }
                    else {
                        this.ngModel = response.user_id;
                        this.ngModelChange.emit(response.user_id);
                        this.display = response.name;
                    }
                }
            }
        });
    }


}



// WEBPACK FOOTER //
// ./src/app/shared/select-user/select/select.component.ts